import {Component} from "../../../gvf/js/component";

export class ModPricing extends Component{
    constructor(scope,$root){
        super(scope,$root);
        this.$check = null;
        this.$input = null;
    }

    getVal(){
        return this.$check.get(0).checked;
    }

    setVal(val,noEvent){
        this.$check.prop("checked",!!val);
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$check = this.$root.find("[type=checkbox]");
        this.$input = this.$root.find(":input");
        this.price = this.$root.find(this.scope+"__price");
        this.price1 = this.$root.find(this.scope+"__price1");
        this.price2 = this.$root.find(this.scope+"__price2");
        this.time = this.$root.find(this.scope+"__time");
        this.time1 = this.$root.find(this.scope+"__time1");
        this.time2 = this.$root.find(this.scope+"__time2");

        if(this.$root.data('variable-price')==1){
            this.price.addClass('hidden');
            this.price1.addClass('hidden');
            this.price2.addClass('show');

            this.time.addClass('hidden');
            this.time1.addClass('hidden');
            this.time2.addClass('show');
        }
        this.$check.on(
            "change",
            (ev) => {
                this.price1.toggle("hidden");
                this.price2.toggle("hidden");

                this.time1.toggle("hidden");
                this.time2.toggle("hidden");
            }
        );
    }
}
